import React from "react";
import { Box, Typography, Button, Badge } from "@mui/material";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import AddIcon from "@mui/icons-material/Add";

export default function ConfigurationHeader() {
  return (
    <Box
      sx={{
        background: "#ffffff",
        borderBottom: "0px solid #e5e7eb",
        px: 3,
        py: 2,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      {/* LEFT — Title */}
      {/* <Box>
        <Typography fontWeight={700} fontSize={22}>
          Device Configuration
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Manage device profiles and configuration deployment
        </Typography>
      </Box> */}

      {/* RIGHT — Actions */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        
        {/* Notification Bell with red dot */}
        {/* <Badge
          color="error"
          variant="dot"
          overlap="circular"
        >
          <NotificationsNoneIcon
            sx={{ fontSize: 26, color: "#6b7280", cursor: "pointer" }}
          />
        </Badge> */}

        {/* Create Profile Button */}
        {/* <Button
          variant="contained"
          startIcon={<AddIcon />}
          sx={{
            background: "#1976d2",
            textTransform: "none",
            borderRadius: "10px",
            px: 2.5,
            fontWeight: 600,
          }}
        >
          Create Profile
        </Button> */}
      </Box>
    </Box>
  );
}
